import "./App.css";
import HomePageWithToken from "./pages/HomePageWithStatus";
import Home from "./pages/HomePage/HomePage";

function App() {
  return (
    <div className="font-poppins select-none">
      <Home />
    </div>
  );
}

export default App;
